import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { create } from "lodash";
import * as institutionAPI from "../../api/institution";
import { toast } from "react-toastify";

const initialState = {
  loading: false,
  activeInstitutions: null,
  newInstitutionList: [],
  redirect: false,
  perPage: 10,
  page: 1,
  offset: 0,
};

const addInstitution = createAsyncThunk(
  "institution/add",
  async (params, { rejectWithValue }) => {
    try {
      const res = await institutionAPI.addInstitution(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
        toast.success("Institution Added Successfully");
      }
      return res.data;
    } catch (error) {}
  }
);

const getInstitution = createAsyncThunk(
  "institution/get",
  async (params, { rejectWithValue }) => {
    try {
      const res = await institutionAPI.getInstitutions(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
      }
      return res.data.body;
    } catch (error) {}
  }
);

const deleteInstitution = createAsyncThunk(
  "institution/delete",
  async (params, { rejectWithValue, getState }) => {
    try {
      const { id } = params;
      if (id) {
        const listOfInstitution =
          getState().institution?.newInstitutionList?.institutions;
        const { status } = listOfInstitution.find((item) => item.id === id);
        params.status = status === "Active" ? "InActive" : "Active";
      }
      const res = await institutionAPI.deleteInstitution(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      }
      return res.data;
    } catch (error) {
      // console.error("error", error);
      return rejectWithValue(error);
    }
  }
);
const updateInstitution = createAsyncThunk(
  "institution/update",
  async (params, { rejectWithValue }) => {
    try {
      const res = await institutionAPI.updateInstitution(params);
      if (res.data.statusCodeValue >= 400) {
        return rejectWithValue(res.data.body.error);
      } else {
      }
      return res.data;
    } catch (error) {}
  }
);
const institutionSlice = createSlice({
  name: "institution",
  initialState,
  reducers: {
    setActiveInstitutions: (state, action) => {
      //console.log(action.payload, 'action23')
      state.activeInstitutions = action.payload;
    },

    setRedirection: (state, action) => {
      state.redirect = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setOffset: (state, action) => {
      state.offset = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getInstitution.fulfilled, (state, action) => {
        // toast.success(action.payload.body.success);

        return { ...state, newInstitutionList: action.payload };
      })
      .addCase(deleteInstitution.fulfilled, (state, action) => {
        toast.success(action.payload.body);
      })
      .addCase(updateInstitution.fulfilled, (state, action) => {
        toast.success(action.payload.body);
      });
  },
});

const { setActiveInstitutions, setRedirection, setPerPage,
  setOffset,
  setPage, } = institutionSlice.actions;
export default institutionSlice.reducer;
export {
  addInstitution,
  getInstitution,
  updateInstitution,
  deleteInstitution,
  setActiveInstitutions,
  setRedirection,
  setPerPage,
  setOffset,
  setPage,
};
